import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DurationStatusPipe} from './duration-status.pipe';

@NgModule({
  declarations: [DurationStatusPipe],
  exports: [DurationStatusPipe],
  imports: [CommonModule],
})
export class DurationStatusModule {}
